module.exports = __webpack_public_path__ + "img/位置.336a7f00.png";